var _mask, _g, _mask2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2604 0.00463867H1.76753C0.80361 0.00827191 0.0247532 0.791895 0.027 1.75582L0 14.0045L0.99072 13.9997L1.01814 1.85193L9.7426 7.59503C9.82344 7.64787 9.91789 7.67608 10.0145 7.6762C10.1096 7.67629 10.2027 7.64877 10.2825 7.59698L19.0093 1.95424L19.0096 12.2558C19.0105 12.6705 18.6754 13.0076 18.2607 13.0091H3.00328V14.0045H18.2607C19.2235 14.0008 20.0016 13.2186 20.0003 12.2558L20 1.75339C20.0013 0.790624 19.2232 0.00840309 18.2604 0.00463867Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 -6H-2V18H22V-6Z",
    fill: "#0E5AA7"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 18,
    height: 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2012 1.03113H1.7083C1.64732 1.03559 1.58716 1.04784 1.5293 1.06759L9.03586 6.00959L9.97929 6.60188L18.498 1.09415C18.4045 1.05285 18.3034 1.03139 18.2012 1.03113Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M22 -6H-2V18H22V-6Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLogo);
export default __webpack_public_path__ + "static/media/emailLogo.8885ecc2035115799d7eb948dbabc95fa9d421aa772d777e0ddb95aa5218a1ee.svg";
export { ForwardRef as ReactComponent };